import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Icon } from "@/comn/components";
import { _TEST1234 } from "../../config/ApiConfig";
import { useTheme } from "@/comn/hooks";
import { sync } from "../../context/LabelContext";

export const LoginHeaderLanguageSelect = () => {
    const { theme, setTheme } = useTheme();
    const { t } = useTranslation();

    const [pending, setPending] = useState(false);

    const handleClick = async () => {
        if (pending) return;
        setPending(true);
        await sync();
        setPending(false);
    };

    return (
        <div className="flex h-[36px] gap-[1px]">
            <div className="relative flex items-center h-full">
                <select
                    className="h-full w-[80px] bg-black/10 rounded-l text-primary-contrast outline-none p-1 appearance-none hover:bg-black/20"
                    value={theme.lang}
                    onChange={(e) => {
                        setTheme((prev) => ({ ...prev, lang: e.target.value as "ko" | "en" | "tz" }));
                    }}
                >
                    <option className="text-black" value="ko">
                        {t("L_KO")}
                    </option>
                    <option className="text-black" value="en">
                        {t("L_EN")}
                    </option>
                    <option className="text-black" value="tz">
                        {t("L_SW")}
                    </option>
                </select>
                <Icon
                    icon="down"
                    size="xs"
                    className="absolute right-[10px] pointer-events-none text-primary-contrast"
                />
            </div>
            <button
                className={classNames(
                    "flex items-center justify-center bg-black/10 px-1 rounded-r",
                    "hover:bg-black/20",
                    pending && "pointer-events-none",
                )}
                onClick={handleClick}
            >
                {pending ? (
                    <Icon icon="loading" className="animate-spin text-primary-contrast" size="xs" />
                ) : (
                    <Icon icon="download" size="xs" className="text-primary-contrast" />
                )}
            </button>
        </div>
    );
};
